import $ from 'jquery';
import { namespace } from '../../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractResizeHandle from '../handle/abstractResizeHandle';

/**
 * @extends AbstractResizeHandle
 */
export default class CreateCutangleToolView extends AbstractResizeHandle {
    /**
     * @constructor
     * @param {Ofcs.Editor.Svg.Canvas} canvas
     * @param {Ofcs.Editor.Svg.Tool.CreateCutangleTool} createTool
     */
    constructor(canvas, createTool) {
        super(createTool, canvas);

        this.canvas = canvas;
        this.createTool = createTool;
        this.cache = new Ofcs.Cache();
        this.handles = {};
        this.invalid = null;

        this.initializeHandleSymbols(canvas);

        this.createTool.on('updateFirstPoint', (...args) => this._onUpdate(...args));
        this.createTool.on('abort', (...args) => this.remove(...args));

        canvas.on('zoomchange', () => this.updateElementsPositions());
        canvas.on('panchange', () => this.updateElementsPositions());
    }

    /**
     * Handles updates for mousemove events
     *
     * @param {Point} pointParam current mouse position
     * @param {boolean} invalid update status; if true point lies within invalid segment
     * @private
     */
    _onUpdate(pointParam, invalid) {
        const { options } = this.canvas;
        const zoomMatrix = new Ofcs.Matrix();
        const point = pointParam.clone();
        const handlesLayer = this.canvas.getLayerManager().getElement('ui.handles');

        this.invalid = invalid;
        this.handles.pos = point.clone();

        this.handles.item = this.cache.get('item', () => {
            const svg = this.canvas.getSvgWrapper();
            this.handles.parent = this.handles.parent || $(svg.group(handlesLayer));
            return this.createPointerElement(point, this.handles.parent);
        });

        zoomMatrix.translate(-this.HANDLE_SIZE / 2, -this.HANDLE_SIZE / 2)
            .scale(options.zoom)
            .translate(options.panX, options.panY);
        point.transform(zoomMatrix);

        this.handles.item.attr({ x: point.x, y: point.y });
        if (invalid) {
            this.handles.item.attr({
                fill: 'url(#handleResizeInvalidBg)',
                stroke: 'url(#handleResizeStrokeInvalidColor)',
            });
        } else {
            this.handles.item.attr({
                fill: 'url(#handleResizeBg)',
                stroke: 'url(#handleResizeStrokeColor)',
            });
        }
    }

    /**
     * Create a handle at the specified position.
     *
     * @param {Point} point
     * @param {element} parentEl
     * @return {jQuery}
     */
    createPointerElement(point, parentEl) {
        const svg = this.canvas.getSvgWrapper();

        return $(svg.rect(parentEl, point.x, point.y, this.HANDLE_SIZE - 1, this.HANDLE_SIZE - 1, 1, 1, {
            fill: 'url(#handleResizeBg)',
            stroke: 'url(#handleResizeStrokeColor)',
            strokeWidth: 0.5,
            style: 'cursor: pointer',
            class: 'resize-handle',
        }));
    }

    /**
     * Updates the position of internal DOM elements based on the attributes
     * of the first point.
     */
    updateElementsPositions() {
        const { options } = this.canvas;
        const zoomMatrix = new Ofcs.Matrix();

        zoomMatrix.translate(-this.HANDLE_SIZE / 2, -this.HANDLE_SIZE / 2)
            .scale(options.zoom)
            .translate(options.panX, options.panY);

        if (this.handles.item) {
            const point = this.handles.pos.clone();
            point.transform(zoomMatrix);
            this.handles.item.attr({ x: point.x, y: point.y });
        }
    }

    /**
     * Removes the DOM nodes from the canvas and deactivates all event listeners
     */
    remove() {
        const handlesLayer = $(this.canvas.getLayerManager().getElement('ui.handles'));
        handlesLayer.find('g').remove();
        this.handles = {};
        this.cache.clear();
        this.invalid = null;
    }
}

namespace('Ofcs.Editor.Svg.ToolView');
window.Ofcs.Editor.Svg.ToolView.CreateCutangleToolView = CreateCutangleToolView;
